(function () {

    angular
        .module('smartertoolsApp')
        .controller('priceQuotesCtrl', ['$scope', '$timeout', 'ticketService', '$q', 'authenticationService', 'pricequotes', 'cacheControl', 'notificationFactory', '$window', '$http', priceQuotesCtrl]);

    function priceQuotesCtrl($scope, $timeout, ticketService, $q, authenticationService, pricequotes, cacheControl, notify, $window, $http) {
        var vm = this;
        vm.selectedPriceQuote = null;
        vm.dateOnServer = Date.now();
        vm.requestQuoteData = {
            status: null
        };

        // Functions
        vm.refresh = refresh;
        vm.viewPriceQuote = viewPriceQuote;
        vm.modalShowPage = modalShowPage;
        vm.modalShowPaymentPage = modalShowPaymentPage;
        vm.getPrimaryEmail = getPrimaryEmail;
        vm.sendEmail = sendEmail;
        vm.modalPayQuoteZero = modalPayQuoteZero;
        vm.modalPayQuote = modalPayQuote;
        vm.refreshInvoicesAndClosePayModal = refreshInvoicesAndClosePayModal;
        vm.submitFeedback = submitFeedback;
        vm.submitTickets = submitTickets;
        vm.customerEmail = authenticationService.getLoggedInEmail();

        activate();

        // -----------------------------------------------

        function activate() {
            vm.refresh();
            $scope.$on('cache-clear', function (event, data) {
                refresh();
            });
            vm.getPrimaryEmail();
        }

        function isExpired(value, index, array) {
            return value.DateExpiresUtc < Date.now();
        }

        function isNotExpired(value, index, array) {
            return value.DateExpiresUtc >= Date.now();
        }

        function refresh() {
            var now = +new Date();
            var oneDay = 60 * 60 * 24 * 1000;

            $scope.accountCtrl.isLoading++;
            pricequotes.getPriceQuotes()
                .then(function (quotes) {
                    $scope.accountCtrl.isLoading--;
                    vm.priceQuotesOriginal = quotes;
                    var active = [];
                    for (let i = 0; i < quotes.length; i++) {
                        var item = quotes[i];
                        item.rowClass = '';
                        if (new Date(item.DateExpiresUtc) < Date.now()) {
                            active.push(item);
                            item.rowClass = 'mark-danger';
                        } else {
                            active.push(item);
                            var within15Days = (new Date(item.DateExpiresUtc) < (Date.now() + (oneDay * 15)));
                            item.rowClass = within15Days ? 'mark-warning' : '';
                        }
                    }
                    active.sort((a, b) => new Date(b.DateExpiresUtc) - new Date(a.DateExpiresUtc));
                    vm.priceQuotes = active;
                    authenticationService.showTermsCondition((data) => {
                        var showAgreement = data;
                        if (showAgreement == true) {
                            ShowTermsAgreementOverlay();
                        }
                    });
                })
                .catch((err) => $scope.accountCtrl.isLoading--);
        }

        function viewPriceQuote(quote) {
            quote.isExpired = new Date(quote.DateExpiresUtc) < Date.now();
            vm.selectedPriceQuote = quote;
            vm.modalPage = 'start';
            vm.isSending = false;
            bootstrap.Modal.getOrCreateInstance(document.getElementById('priceQuotes-view-modal')).show();
        }

        function submitFeedback() {
            vm.requestQuoteData.status = 'submitting';

            $http
                .post(apiRootUrl + 'v1/feedback/price-quote-request', JSON.stringify({
                    Name: vm.requestQuoteData.name,
                    Email: vm.requestQuoteData.email,
                    Company: vm.requestQuoteData.company,
                    Phone: vm.requestQuoteData.phone,
                    Message: vm.requestQuoteData.message,
                }))
                .then((response) => {
                    vm.requestQuoteData.status = 'done';
                    $scope.$applyAsync();
                }, () => {
                });
        }

        function modalShowPaymentPage() {
            if (vm.selectedPriceQuote.Total <= 0)
                vm.modalShowPage('pay-zero');
            else
                vm.modalShowPage('pay');
        }

        function modalShowPage(mode) {
            vm.modalPage = mode;
            if (mode === 'email') {
                vm.priceQuoteSendEmailForm.$setPristine();
                vm.priceQuoteSendEmailForm.$setUntouched();
                $timeout(() => document.getElementById('PriceQuoteSendEmailAddress').focus(), 100);
            }
        }

        function sendEmail() {
            if (vm.priceQuoteSendEmailForm.$invalid)
                return;
            vm.isSending = true;
            pricequotes.sendThroughEmail(vm.selectedPriceQuote.PriceQuoteGuid, vm.emailToSend)
                .then(() => {
                    vm.isSending = false;
                    vm.modalShowPage('email-sent');
                })
                .catch(() => {
                    vm.isSending = false;
                    notify.error('There was a problem sending the email.');
                });
        }

        function modalPayQuoteZero() {
            vm.isSending = true;
            pricequotes.payInvoiceZero(vm.selectedPriceQuote.PriceQuoteGuid)
                .then((result) => {
                    if (result.Successful === true)
                        vm.submitTickets();
                    vm.paymentResult = result;
                    vm.isSending = false;
                    vm.modalShowPage('pay-results');
                })
                .catch(() => {
                    vm.isSending = false;
                    notify.error('There was a problem making the payment.');
                });
        }

        function modalPayQuote() {
            vm.isSending = true;
            if (vm.selectedPaymentMethod.PaymentType === 'card') {
                pricequotes.payExistingCard(vm.selectedPriceQuote.PriceQuoteGuid, vm.selectedPaymentMethod)
                    .then((result) => {
                        if (result.Successful === true)
                            vm.submitTickets();
                        vm.paymentResult = result;
                        vm.isSending = false;
                        vm.modalShowPage('pay-results');
                    })
                    .catch(() => {
                        vm.isSending = false;
                        notify.error('There was a problem making the payment.');
                    });
            } else if (vm.selectedPaymentMethod.PaymentType === 'new') {
                pricequotes.payNewCard(vm.selectedPriceQuote.PriceQuoteGuid, vm.selectedPaymentMethod)
                    .then((result) => {
                        if (result.Successful === true)
                            vm.submitTickets();
                        vm.paymentResult = result;
                        vm.isSending = false;
                        vm.modalShowPage('pay-results');
                    })
                    .catch(() => {
                        vm.isSending = false;
                        notify.error('There was a problem making the payment.');
                    });
            } else if (vm.selectedPaymentMethod.PaymentType === 'invoice') {
                pricequotes.payInvoiceLater(vm.selectedPriceQuote.PriceQuoteGuid)
                    .then((result) => {
                        if (result.Successful === true)
                            vm.submitTickets();
                        vm.paymentResult = result;
                        vm.isSending = false;
                        vm.modalShowPage('pay-results');
                    })
                    .catch(() => {
                        vm.isSending = false;
                        notify.error('There was a problem making the payment.');
                    });
            }
        }

        function refreshInvoicesAndClosePayModal() {
            cacheControl.clearAllCaches();
            $window.location.reload();
        }

        function getPrimaryEmail() {
            ticketService.getAccountSettings()
                .then(data => {
                    if (data) {
                        vm.primaryEmail = data.Details.EmailAddress;
                    }
                });
        }

        function submitTickets() {
            var details = {};
            var promises = [];
            // customer email is actually the logged in user email, so handle accordingly.
            var userEmail = vm.customerEmail === vm.primaryEmail
                ? ''
                : vm.customerEmail;

            for (var i = 0; i < vm.selectedPriceQuote.Items.length; i++) {
                var item = vm.selectedPriceQuote.Items[i];

                switch (item.OriginalProductId) {
                    case 1207:
                        details = {
                            IsEmergency: false,
                            IsInstall: true,
                            IsTraining: false,
                            FromAddress: vm.primaryEmail,
                            CCAddress: userEmail,
                            Subject: 'SmarterTools Installation Assistance',
                            rawBody: vm.primaryEmail + ' has submitted an Installation Assistance request.',
                            Body: vm.primaryEmail + ' has submitted an Installation Assistance request.',
                            IsHtml: false,
                            IsFree: true
                        };
                        promises.push(ticketService.submitTicket(details));
                        break;
                    case 788:
                        isFree = item.ListPrice <= 0;
                        details = {
                            IsEmergency: false,
                            IsInstall: true,
                            IsTraining: false,
                            FromAddress: vm.primaryEmail,
                            CCAddress: userEmail,
                            Subject: 'SmarterTools Installation Assistance',
                            rawBody: vm.primaryEmail + ' has submitted an Installation Assistance request.',
                            Body: vm.primaryEmail + ' has submitted an Installation Assistance request.',
                            IsHtml: false,
                            IsFree: isFree
                        };
                        promises.push(ticketService.submitTicket(details));
                        break;
                    case 789:
                        details = {
                            IsEmergency: false,
                            IsInstall: false,
                            IsTraining: true,
                            FromAddress: vm.primaryEmail,
                            CCAddress: userEmail,
                            Subject: 'SmarterTools Product Training',
                            rawBody: vm.primaryEmail + ' has purchased Product Training.',
                            Body: vm.primaryEmail + ' has purchased Product Training.',
                            IsHtml: false,
                            IsFree: isFree
                        };
                        promises.push(ticketService.submitTicket(details));
                        break;
                }
            }

            if (!promises.length)
                return;

            $q.all(promises)
                .then((arr) => {
                })
                .catch(() => {
                });
        }
    }

})();